import React from 'react';

const UnChanged = ({ ismodal, setismodal ,fun}) => {
  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative w-full max-w-md p-6 bg-white rounded-lg text-start border border-gray-300 shadow-sm">
        {/* Close Icon */}
        <button
          onClick={() => setismodal(false)}
          className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded-md bg-red-900 text-white text-sm hover:opacity-90"
        >
          ×
        </button>

        {/* Heading */}
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">Are you sure Confirm it ?</h2>

        {/* Message */}
        <p className="text-sm text-gray-700 mb-4">
        You have unsaved changes. Please review your data before changing.
        </p>
        <div className='flex justify-end gap-4'>

              {/* Cancel Button */}
        <button
          onClick={() => setismodal(false)}
          className="px-4 py-2 text-sm font-medium text-white bg-[#900] rounded-md"
        >
          No
        </button>
        <button
          onClick={() => fun()}
          className="px-4 py-2 text-sm font-medium text-white bg-[#900] rounded-md"
        >
         Yes
        </button>
        </div>

      
      </div>
    </div>
  );
};

export default UnChanged;
